// Nm <-> lb-ft Calculator tool: unit metadata + client-side field validation, used for
// instant inline feedback as the user types. The actual conversion math and the
// authoritative (server-side) validation live in the main backend — see
// src/lib/toolsApi.js (torqueToolApi) and backend/tools/torque_tool.py.

export const DEFAULT_INPUTS = {
  unit: 'nm',
  value: 100,
};

// N*m is the canonical/base unit — every other unit's factor below is "1 <unit> = X N*m".
// Order here drives the order results are displayed in.
export const UNITS = [
  { value: 'nm', label: 'N·m', name: 'Newton-Meters' },
  { value: 'lbft', label: 'lb-ft', name: 'Pound-Feet' },
  { value: 'lbin', label: 'lb-in', name: 'Pound-Inches' },
  { value: 'kgfm', label: 'kgf·m', name: 'Kilogram-Force Meters' },
  { value: 'kgfcm', label: 'kgf·cm', name: 'Kilogram-Force Centimeters' },
  { value: 'ozin', label: 'oz-in', name: 'Ounce-Inches' },
  { value: 'dyncm', label: 'dyn·cm', name: 'Dyne-Centimeters' },
];

// Torque direction is meaningful in automotive contexts (unlike power), so negative
// values are allowed here — unlike the kW ↔ HP Calculator's non-negative Value field.
// Mirrors FIELD_SPECS in backend/core/lookup/torque_specs.py exactly.
export const FIELD_SPECS = [
  { key: 'value', label: 'Value', unit: '', group: 'input', min: -1000000, max: 1000000, strictlyPositive: false },
];

export const PRECISION_OPTIONS = [2, 3, 4, 5, 6];
export const DEFAULT_PRECISION = 4;

export function validateField(spec, rawValue) {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    return 'Required.';
  }
  const value = Number(rawValue);
  if (Number.isNaN(value)) {
    return 'Must be a number.';
  }
  if (spec.strictlyPositive && value <= 0) {
    return 'Must be greater than 0.';
  }
  if (spec.min !== null && value < spec.min) {
    return `Must be ≥ ${spec.min}.`;
  }
  if (spec.max !== null && value > spec.max) {
    return `Must be ≤ ${spec.max}.`;
  }
  return null;
}
